import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import ToggleAssigneeTagRequest from "../request/ToggleAssigneeTagRequest";

const ToggleAssigneeTagApiService = async (
  request: ToggleAssigneeTagRequest
): Promise<boolean> => {
  const actionUrl = request.isTagged ? "tag_employee" : "un_tag_employee";
  const url = `/employertag/${request.tagId}/${actionUrl}/`;
  const { data } = await axios.post(url, {
    employee_id: request.employeeId,
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useToggleAssigneeTagApiService = () =>
  useMutation<boolean, AxiosError, ToggleAssigneeTagRequest>(
    ToggleAssigneeTagApiService,
    {
      mutationKey: ["ToggleAssigneeTagApiService"],
    }
  );
export default useToggleAssigneeTagApiService;
